import apiClient, { ssoApiClient } from './apiClient';

export const authService = {
  async login(username, password, userId = null) {
    const payload = {
      username,
      password,
      platform: 'student_web'
    };

    if (userId !== null && userId !== undefined) {
      payload.userId = Number(userId);
    }

    const response = await apiClient.post('/auth/login', payload);

    // If phone verification or multi-account selection is required, return content so presentation layer can show the dialog
    if (response?.content?.requiresPhoneVerification || response?.content?.requiresAccountSelection) {
      return response.content;
    }

    if (response && response.isSuccessful) {
      const user = response.content?.user;
      if (user?.role !== 'student') {
        throw new Error('Access denied. Only student accounts are allowed to log in here.');
      }
      return response.content;
    }

    throw new Error(response?.message || 'Login failed');
  },

  async requestPhoneVerification({ userId, phone_number, email, user_name }) {
    const payload = { phone_number, user_name };
    if (userId !== null && userId !== undefined) {
      payload.user_id = Number(userId);
    }
    if (email && email.trim() !== '') {
      payload.email = email;
    }
    const response = await ssoApiClient.post('/sso-auth/register/request-phone-verification', payload);
    if (response && response.isSuccessful) {
      return response.content;
    }
    throw new Error(response?.message || 'Failed to request OTP');
  },

  async completePhoneVerification({ userId, otp_code, phone_number, email, password }) {
    const payload = { userId, otp_code, phone_number };
    if (email && email.trim() !== '') {
      payload.email = email;
    }
    if (password) {
      payload.password = password;
    }
    const response = await ssoApiClient.post('/sso-auth/register/complete-phone-verification-mobile', payload);
    if (response && response.isSuccessful) {
      return response.content;
    }
    throw new Error(response?.message || 'Failed to verify OTP');
  },

  async forgotPasswordInitiate(identifier, userId = null) {
    const payload = { identifier };
    if (userId !== null && userId !== undefined) {
      payload.userId = Number(userId);
    }
    const response = await ssoApiClient.post('/sso-auth/forogot-password/initiate', payload);
    if (response && response.isSuccessful) {
      return response;
    }
    throw new Error(response?.message || 'Failed to initiate password reset');
  },

  async forgotPasswordVerify(identifier, otpCode, userId = null) {
    const payload = { otp_code: otpCode };
    if (userId !== null && userId !== undefined) {
      payload.userId = Number(userId);
      payload.identifier = identifier || '';
    } else {
      payload.identifier = identifier;
    }
    const response = await ssoApiClient.post('/sso-auth/forogot-password/verify', payload);
    if (response && response.isSuccessful) {
      return response;
    }
    throw new Error(response?.message || 'Failed to verify OTP');
  },

  async forgotPasswordComplete(identifier, otpCode, newPassword, confirmPassword, userId = null) {
    const payload = {
      otp_code: otpCode,
      new_password: newPassword,
      confirm_password: confirmPassword
    };
    if (userId !== null && userId !== undefined) {
      payload.userId = Number(userId);
      payload.identifier = identifier || '';
    } else {
      payload.identifier = identifier;
    }
    const response = await ssoApiClient.post('/sso-auth/forogot-password/complete', payload);
    if (response && response.isSuccessful) {
      return response;
    }
    throw new Error(response?.message || 'Failed to reset password');
  }
};

export default authService;
